module.exports = __webpack_public_path__ + "static/img/header_1.53fac3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/header_1.png
// module id = um3w
// module chunks = 18